import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class JelSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
